<template>
  <div :class="'bookable ' + getBookableClass(bookable)">
    <div class="bookable__wrap">
      <h3 v-html="getName(bookable)"></h3>
      <h3 class="bookable-not-available-notice">
        Sorry, this room is not available for your chosen dates
      </h3>

      <div class="bookable__info">
        <p
          v-html="getSleeps(bookable)"
          class="bookable__sleeps"
        ></p>

        <div
          class="calendar"
          v-if="$store.state.showBookableCalendar === bookable.id"
        >
          <div class="calendar__wrap">
            <v-date-picker
              :value="null"
              :min-date="new Date()"
              :max-date="maxDate"
              :attributes="$store.state.bookableAttributes"
              :available-dates="$store.state.bookableCalendar.availableCheckInDates"
              :disabled-dates="$store.state.bookableCalendar.disabledDates"
              is-linked
              is-inline
              readonly
              :isDoublePaned="$store.state.calendarHasDoublePane"
              :is-expanded="!$store.state.calendarHasDoublePane"
              @update:topage="paginate($event)"
              @update:frompage="paginate($event)"
            ></v-date-picker>
          </div>

          <div class="calendar-key calendar-key--small">
            <span>key:</span>
            <ul>
              <li class="checkinoutday" data-days="12"><span>Available check in</span></li>
              <li class="available" data-days="12"><span>Available</span></li>
              <li class="booked"><span>Booked</span></li>
            </ul>
          </div>
        </div>
        <button
          v-if="$store.state.showBookableCalendar === bookable.id"
          @click="$store.state.showBookableCalendar = null"
          class="calendar__close"
          aria-label="close"
        >
          X
        </button>
        <div>
          <p
            v-html="getNightlyPriceFrom(bookable)"
            class="bookable__price-from"
          ></p>
          <p
            v-if="hasWeeklyPricing()"
            v-html="getWeeklyPriceFrom(bookable)"
            class="bookable__price-from"
          ></p>
        </div>
      </div>

      <div v-if="isDemoMode && $store.state.dateSelectionComplete">
        <div :key="index" v-for="(data, index) in $store.state.apiDates.bookables_data">
          <div v-if="data.bookable == bookable && data.dates.length > 0">
            <span
              v-if="data.dates.length == $store.state.selectedDate.length - 1"
            >
              Available for <b>ALL</b> of your dates
            </span>
            <span
              v-if="
                data.dates.length != $store.state.selectedDate.length - 1 &&
                  data.dates.length > 0
              "
            >
              Available for <b>{{ data.dates.length }}</b> of your dates
            </span>
          </div>
        </div>
      </div>

      <div class="bookable__availability-btn">
        <button
          @click="toggleBookablesCalendar(bookable.id)"
          v-if="
            $store.state.place.availability_cal &&
              $store.state.showBookableCalendar !== bookable.id
          "
        >
          Check availability
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  /* Import moment directly to stop loading ALL locales
   * See: https://stackoverflow.com/questions/25384360/how-to-prevent-moment-js-from-loading-locales-with-webpack
   */
  import moment from "moment/src/moment";

  export default {
    name: "BookableItems",
    props: {
      id: {
        default: null,
        type: Number
      }
    },
    computed: {
      isDemoMode: function() {
        return this.$store.state.demoMode;
      },
      bookable: function() {
        return this.$store.state.place.bookables[this.id];
      },
      showAvailabilityBtn: function() {
        if (
          this.$store.state.place.availability_cal == true &&
          this.$store.state.showBookableCalendar !== this.bookable.id
        ) {
          return true;
        } else {
          return false;
        }
      },
      maxDate() {
          return new Date(this.$store.state.apiDates.minMaxDates.end);
      }
    },
    methods: {
      getBookableClass: function(bookable) {
        let classNames = "";
        classNames += this.isBookableAvailable(bookable)
          ? "is-available"
          : "not-available";
        classNames +=
          this.$store.state.showBookableCalendar === bookable.id
            ? " is-open"
            : " is-closed";
        return classNames;
      },
      isBookableDisabled: function(bookable) {
        if (
          this.$store.state.dateSelectionComplete &&
          !this.isBookableAvailable(bookable)
        ) {
          return true;
        } else {
          return false;
        }
      },
      isBookableAvailable: function(bookable) {
        let isAvailable = true;

        if (this.$store.state.dateSelectionComplete) {
          const bookablesData = this.$store.state.apiDates.bookables_data;

          for (var i = 0; i < bookablesData.length; i++) {
            if (
              bookablesData[i].bookable === bookable &&
              bookablesData[i].dates.length < 1
            ) {
              isAvailable = false;
            }
          }
        }

        return isAvailable;
      },
      toggleBookablesCalendar: function(bookable) {
        let queryParams = {
          bookableId: bookable,
          startDate: "date",
          endDate: "date"
        };

        this.$store.dispatch({
          type: "trackGaEvent",
          eventCategory: "Availability calendar",
          eventAction: "Bookable calendar opened"
        });

        this.$store.dispatch("showBookableCalendar", queryParams);

        this.$store.dispatch("clearBookablesCalendarDates");

        // Reset pagination
        this.$store.state.bookableCalendarPaginationKey = {
          year: moment().year(),
          month: moment().month()
        };
      },
      getName(bookable) {
        let name = bookable.type;
        // const typesWithCapacity = [
        //     'double',
        //     'twin',
        //     'twin/double',
        //     'single',
        //     'triple',
        //     'quadruple',
        //     'four-poster',
        // ]

        // if (typesWithCapacity.indexOf(name.toLowerCase()) === -1) {
        //     name = bookable.quantity + ' x ' + bookable.type
        // }

        let nameSuffix = "";

        if (bookable.quantity > 1) {
          nameSuffix = "s";
        }

        name = bookable.quantity + " " + bookable.type + nameSuffix;

        return name;
      },
      getSleeps(bookable) {
        return "Sleeps " + bookable.sleeps;
      },
      // Duplication, this presentation can be found getPlaceMinPriceFromPerWeek inside store.js
      getNightlyPriceFrom(bookable) {
        let priceString = "";
        if (
          parseInt(bookable.maxPricePerNight) >
          parseInt(bookable.minPricePerNight)
        ) {
          priceString =
            "From " +
            this.$store.getters.currencySymbol +
            bookable.minPricePerNight +
            " to " +
            this.$store.getters.currencySymbol +
            bookable.maxPricePerNight +
            " per night";
        } else {
          priceString =
            this.$store.getters.currencySymbol +
            bookable.minPricePerNight +
            " per night";
        }

        return priceString;
      },
      // Duplication, this presentation can be found getPlaceMinPriceFromPerWeek inside store.js
      getWeeklyPriceFrom(bookable) {
        let priceString = "";
        if (
          parseInt(bookable.maxPricePerWeek) >
          parseInt(bookable.minPricePerWeek)
        ) {
          priceString =
            "From " +
            this.$store.getters.currencySymbol +
            bookable.minPricePerWeek +
            " to " +
            this.$store.getters.currencySymbol +
            bookable.maxPricePerWeek +
            " per week";
        } else {
          priceString =
            this.$store.getters.currencySymbol +
            bookable.minPricePerWeek +
            " per week";
        }

        return priceString;
      },
      hasWeeklyPricing() {
        if (this.$store.state.place.accommodation_type == "self-catering") {
          return true;
        } else {
          return false;
        }
      },

      /**
       * Determine if the user has paginated far enough to require an API call
       * 
       * @param {{year:number,month:number}} requested Requested year/month
       * @return {boolean}                             Should call API?
       */
      needsToCallApi(requested) {
        const current = this.$store.state.bookableCalendarPaginationKey;

        if (!current) {
          return true;
        }

        return (requested.year > current.year
          || (requested.year == current.year && requested.month > current.month)
        );
      },

      paginate(payload) {
        let queryParams = {};

        if (payload === undefined) {

          queryParams = {
            bookableId: this.bookable.id,
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment(moment().format("YYYY-MM-DD"))
              .add(5, "M")
              .format("YYYY-MM-DD")
          };

          this.$store.dispatch("getBookableCalendarData", queryParams);
        } else {
          if (this.needsToCallApi(payload.monthComps)) {
            if (payload.position !== undefined) {

              let endMonthSanitized = payload.monthComps.month;

              if (payload.monthComps.month < 10) {
                endMonthSanitized = "0" + payload.monthComps.month;
              }

              var endDate = new Date(
                payload.monthComps.year +
                  "-" +
                  endMonthSanitized +
                  "-" +
                  payload.monthComps.days
              );
              let endDatePlusAMonth = moment(endDate)
                .add(1, "M")
                .format("YYYY-MM-DD");

              let prevMonthSanitized = payload.prevMonthComps.month;
              //
              // // This annoying hack to add a '0' to month numbers is due to moment.js falling over when trying to use format("YYYY-M-DD")
              // // or format("YYYY-M-D") but works fine with format("YYYY-MM-DD")
              if (payload.prevMonthComps.month < 10) {
                prevMonthSanitized = "0" + payload.prevMonthComps.month;
              }

              var thisMonth = new Date(
                payload.prevMonthComps.year + "-" + prevMonthSanitized + "-01"
              );
              let thisMonthMinus1Day = moment(thisMonth)
                .subtract(1, "Day")
                .format("YYYY-MM-DD");

              queryParams = {
                bookableId: this.bookable.id,
                startDate: thisMonthMinus1Day,
                endDate: endDatePlusAMonth
              };

              this.$store.dispatch("getBookableCalendarData", queryParams);
              this.$store.state.bookableCalendarPaginationKey = payload.monthComps;
            }
          }
        }

        return;
      }
    }
  };
</script>

<style lang="scss">
  @import "../assets/styles/toolbox.scss";

  .bookable {
    .c-title {
      @include media(max-width, $bp--app-fixed - 1px) {
        font-weight: bold !important;
        font-size: rem(14px) !important;
      }
    }
  }
</style>
<style scoped lang="scss">
  @import "../assets/styles/toolbox.scss";

  .bookable {
    border: 1px solid #979797;
    margin-bottom: rem(10px);
    padding: rem(20px) rem(10px) rem(10px);

    @include media(min-width, $bp--app-fixed) {
      border: none;
      border-bottom: 1px solid #d4d4d4;
      padding: rem(10px) 0 rem(20px);
    }
    .bookable-not-available-notice {
      display: none;
    }
    &.not-available {
      padding: rem(5px) 0;
      // border: none;
      // margin-bottom: 20;
      background-color: rgba(#d8d8d8, 0.9);
      border: 1px solid #979797;
      padding: rem(10px) rem(15px);

      .bookable__wrap {
        padding: rem(10px);
      }

      .bookable-not-available-notice {
        text-align: center;
        position: absolute;
        top: 10px;
        left: 0px;
        width: 80%;
        margin-right: 10%;
        margin-left: 10%;
        display: block;
        opacity: 1;
        margin-top: 40px;
      }

      h3,
      p {
        opacity: 0.2;
      }

      &.is-open {
        background-color: white;
        border: none;
        border-bottom: 1px solid #d4d4d4;
        .bookable-not-available-notice {
          position: relative;
          margin-top: 0px;
          margin-bottom: 30px;
        }
        h3,
        p {
          opacity: 1;
        }
      }

      @include media(min-width, $bp--app-fixed) {
        padding: rem(10px) 0;
      }

      // .bookable__availability-btn {
      //     opacity: 0;
      // }
    }

    h3 {
      font-family: "Roboto", serif;
      font-weight: bold;
      font-size: rem(20px);
      color: #252525;
      margin: 0 0 rem(15px) 0;

      @include media(min-width, $bp--app-fixed) {
        font-size: rem(23px);
      }
    }
  }

  .bookable__wrap {
    position: relative;
  }

  .bookable__price-from {
    font-weight: bold;
    font-size: rem(16px);
    border-top: 1px solid #d4d4d4;
    margin-top: rem(5px);
    padding-top: rem(10px);
    text-align: right;
    @include media(min-width, $bp--app-fixed) {
      font-size: rem(17px);
      border: none;
      margin: 0;
      padding: 0;

      .bookable.is-open & {
        display: none;
      }
    }
  }

  .bookable__sleeps {
    font-size: rem(16px);
    color: #717070;
    margin: 0;
    @include media(min-width, $bp--app-fixed) {
      align-self: flex-start;
      font-size: rem(17px);
    }
  }

  .bookable__info {
    @include media(min-width, $bp--app-fixed) {
      display: flex;
      justify-content: space-between;
    }
  }

  .bookable__availability-btn {
    text-align: right;
    margin-top: rem(40px);

    button {
      border: none;
      background: none;
      padding: 0;
      font-size: rem(18px);
      text-decoration: underline;
      color: #59717f;
      padding: rem(5px) 0;
    }
  }

  .calendar {
    position: relative;
    margin: rem(30px) auto rem(30px);
    max-width: rem(400px);

    @include media(min-width, $bp--app-fixed) {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  .calendar__wrap {
    display: flex;
    justify-content: center;
    padding: 0 0 rem(20px) 0;
  }

  .calendar__close {
    font-weight: bold;
    font-size: rem(32px);
    border: none;
    background: none;
    color: #252525;
    padding: rem(4px);
    line-height: 1;
    position: absolute;
    top: 0;
    right: rem(5px);

    @include media(min-width, $bp--app-fixed) {
      position: absolute;
      // top: - rem(46px);
      right: rem(7px);
      align-self: flex-start;
    }
  }

  .bookable-dates {
    padding: rem(10px);

    p {
      text-decoration: underline;
      margin-bottom: 10px;
    }

    li {
      display: inline-block;
      margin-bottom: 0;
      font-weight: bold;

      &:after {
        content: ",";
        margin-right: 5px;
      }

      &:last-child {
        &:after {
          content: "";
        }
      }
    }
  }

  .calendar-key--small {
    font-size: rem(11px);

    @include media(min-width, 600px) {
      font-size: rem(12px);
    }

    .checkinoutday span {
      vertical-align: inherit;
    }

    .booked {
      span {
        font-size: inherit;
      }

      &::after {
        bottom: 0;
      }
    }

    > span {
      display: none;

      @include media(min-width, $bp--app-fixed) {
        display: inline-block;
        margin-right: rem(10px);
        color: #252525;
        align-self: center;
      }
    }

    ul {
      justify-content: flex-start;

      @include media(min-width, 290px) {
        justify-content: center;
      }
    }

    li {
      margin: 0 rem(10px) rem(10px) 0;

      @include media(min-width, 290px) {
        margin-bottom: 0;
      }

      &:before {
        text-align: center;
        line-height: calc(1em / 0.75); // 12px -> 16px
        vertical-align: middle;
        padding: rem(2px) rem(3px) rem(2px) rem(2px);
      }
    }

    span {
      vertical-align: middle;
    }
  }
</style>
